<template>
    <div class="box" ref="box">
        <!-- 头部 -->
        <div class="v_header flexCenter" ref="getheight">
            <div class="flexCenter">
                <span class="headline mr42">仪表盘</span>
                <el-cascader ref="areas" v-model="valuew" :options="area" @change="handleChange" class="el-cascader"></el-cascader>
                <span v-if="user_type == 'super'" class="v_span input_text ml20 input_button" @click="getPay">支付信息</span>
            </div>

            <div class="flexCenter">
                <el-date-picker
                    size="mini"
                    v-model="value"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="getTime"
                >
                    <!-- format="yyyy 年 MM 月 dd 日" -->
                </el-date-picker>
                <el-button size="mini" class="input_button" @click="getSearch">查找</el-button>
            </div>
        </div>
        <!-- 金额 -->
        <div class="flexCenter mb24" ref="getheight1">
            <div class="flex_down mr24">
                <div class="flexCenter" :class="user_type == 'super' ? 'end' : ''" style="position: relative;">
                    <span class="v_span input_text">剩余奖励金额</span>
                    <span v-if="user_type == 'super'" class="v_span input_text ml20 input_button " style="position: absolute;
    right: 0;     " @click="getAdd">添加</span>
                </div>

                <div>
                    <span class="dollar">￥</span>
                    <span class="balance"> {{ price.balance }}</span>
                </div>
            </div>
            <div class="flex_down mr24">
                <span class="v_span input_text">已经领取奖励金额</span>
                <div>
                    <span class="dollar">￥</span>
                    <span class="balance"> {{ price.sum_red_envelope_amount }}</span>
                </div>
            </div>
            <div class="flex_down">
                <span class="v_span input_text">奖励领取次数</span>
                <span class="balance"> {{ price.total_num }}</span>
            </div>
        </div>

        <div class="v_bottom" :style="'height:' + height + 'px'">
            <div class="chartBox" v-if="chartShow">
                <div id="box"></div>
            </div>
            <div class="flexdown" style="overflow: auto">
                <span class="input_text mb24">地图展示</span>

                <div
                    v-for="(item, index) of area_scan_count"
                    :key="index"
                    :class="index == area_scan_count.length - 1 ? 'margin0 area_scan_count' : 'area_scan_count'"
                    @click="getShen(item)"
                >
                    <div class="flexCenter">
                        <div
                            v-if="index <= 2"
                            :class="index == 0 ? 'one' : '' || index == 1 ? 'two one' : '' || index == 2 ? 'thr one' : ''"
                        >
                            {{ (index += 1) }}
                        </div>
                        <span class="input_text">{{ item.province_name }}</span>
                    </div>
                    <span class="input_text">{{ item.count }}</span>
                </div>
            </div>
        </div>
        <el-dialog :title="row.province_name + '扫码明细'" :visible.sync="resetDialogVisible" width="648px" top="15vh" class="v_dol">
            <el-table
                class="u_table"
                :data="province_dashboard"
                :max-height="300 + 'px'"
                style="width: 100%"
                :header-cell-style="{ textAlign: 'center' }"
                :cell-style="{ 'text-align': 'center' }"
            >
                <el-table-column label="市排行榜">
                    <template slot-scope="scope">
                        <span>{{ (scope.$index += 1) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="city_name" label="市"> </el-table-column>
                <el-table-column prop="count" label="数量"> </el-table-column>
            </el-table>
            <div class="dialog-footer">
                <div class="v_buttons" @click="resetDialogVisible = false">关闭</div>
            </div>
        </el-dialog>
        <el-dialog title="添加奖励金额" :visible.sync="add_balanceDialogVisible" width="648px" top="15vh" class="v_dol1">
            <el-form :model="numberValidateForm" ref="numberValidateForm">
                <el-form-item
                    prop="add_balance"
                    :rules="[
                        { required: true, message: '金额不能为空' },
                        {
                            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
                            message: '请输入合法的金额数字，最多两位小数',
                            trigger: 'change'
                        }
                    ]"
                >
                    <el-input class="el_input" v-model="numberValidateForm.add_balance" clearable placeholder="输入金额"></el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button class="v_buttons" size="mini" @click="resetDialogTrue('numberValidateForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 支付信息 pay_DialogVisible -->
        <el-dialog title="支付信息" :visible.sync="pay_DialogVisible" width="648px" top="15vh" class="v_dol v_dol1">
            <el-form :model="payDetail">
                <div class="flex_center">
                    <el-form-item label="微信公众号 app_id">
                        <el-input v-model="payDetail.app_id" size="mini" clearable placeholder="输入微信公众号 app_id"></el-input>
                    </el-form-item>
                    <el-form-item label="小程序APPID">
                        <el-input v-model="payDetail.sub_app_id" size="mini" clearable placeholder="输入小程序APPID"></el-input>
                    </el-form-item>
                </div>
                <div class="flex_center">
                    <el-form-item label="商户号">
                        <el-input v-model="payDetail.pid" size="mini" clearable placeholder="输入商户号"></el-input>
                    </el-form-item>
                    <el-form-item label="商户key">
                        <el-input v-model="payDetail.key" size="mini" clearable placeholder="输入商户key"></el-input>
                    </el-form-item>
                </div>
                <el-form-item label="商户证书序列号">
                    <el-input v-model="payDetail.wechat_pay_serial_no" size="mini" clearable placeholder="输入商户证书序列号"></el-input>
                </el-form-item>
                <div class="u_pay">
                    <el-form-item label="是否使用商户提现">
                        <el-select v-model="payDetail.use_merchant_withdraw" placeholder="请选择" size="mini">
                            <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <el-form-item label="证书文件">
                    <el-upload
                        multiple
                        :limit="1"
                        ref="upload"
                        accept=""
                        action
                        :on-change="change_mch_cert"
                        :auto-upload="false"
                        :on-remove="handleRemove0"
                        :on-exceed="handleExceed"
                        :file-list="backfillList0"
                    >
                        <el-button size="mini" type="primary" class="input_button">上传证书文件</el-button>
                    </el-upload>
                </el-form-item>
                <el-form-item label="私钥证书文件">
                    <el-upload
                        multiple
                        :limit="1"
                        ref="upload"
                        accept=""
                        action
                        :on-change="change_mch_key"
                        :auto-upload="false"
                        :on-remove="handleRemove"
                        :on-exceed="handleExceed"
                        :file-list="backfillList"
                    >
                        <el-button size="mini" type="primary" class="input_button">上传私钥证书文件</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button class="v_buttons" size="mini" @click="payDialogTrue()">保 存</el-button>
            </div>
        </el-dialog>
        <div class="notificationn" v-if="notificationns">
            <div class="notificationn_left"></div>
            <div>
                <div class="notificationn_dec">{{ msg }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import 'echarts/map/js/china';
export default {
    data() {
        return {
            uploadData: new FormData(),
            backfillList0: [],
            backfillList: [],
            options1: [
                {
                    value: 'yes',
                    label: '使用商户提现'
                },
                {
                    value: 'no',
                    label: '使用企业提现'
                }
            ],
            payDetail: {},
            pay_DialogVisible: false,
            notificationns: false,
            add_balanceDialogVisible: false,
            numberValidateForm: {
                add_balance: ''
            },
            img: require('@/assets/img/arrow-forward-outline.png'),
            valuew: [1],
            area: [],
            regionParams: {
                lazy: true, //	是否动态加载子节点，需与 lazyLoad 方法结合使用
                lazyLoad: this.handleGetClassOrStudent //懒加载调用的方法
            },
            message: [], //产品列表
            chartShow: true,
            chartShow1: true,
            timer: '',
            height: 0,
            price: {}, //balance 余额 sum_red_envelope_amount //已领取 total_num次数
            page: {
                start_time: '', //开始日期
                end_time: '', //结束日期
                product_id: '' //产品id
            },
            area_scan_count: [], //渲染数据
            value: [], //日期
            arr: [],
            row: {}, //点击省的数据
            province_dashboard: [],
            resetDialogVisible: false,
            user_type: ''
        };
    },

    methods: {
        
        drawChina() {
            // 初始化echarts实例
            var myEcharts = this.$echarts.init(document.getElementById('box'));
            document.getElementById('box').style.width = '100%';
            document.getElementById('box').style.height = '100%';
            myEcharts.resize(); // 直接加这句即可
            var option = {
                title: {
                    //标题样式
                    text: '地图展示',
                    padding: [20, 0, 0, 16],

                    textStyle: {
                        fontSize: 16,
                        fontWeight: 400,
                        fontFamily: 'PingFang SC',
                        color: '#333333'
                    }
                },

                tooltip: {
                    //这里设置提示框
                    textStyle: {
                        fontFamily: 'PingFang SC',
                        fontWeight: 400,
                        color: '#000', //文字颜色
                        fontSize: 12 //文字大小
                    },
                    padding: [0, 0],
                    trigger: 'item', //数据项图形触发
                    backgroundColor: '#EFFAFE', //提示框浮层的背景颜色。
                    formatter: (params) => {
                        return params.value
                            ? "<div style='box-shadow: 0px 2px 4px rgba(47, 93, 227, 0.16);width: 119px;padding:10px 8px'>" +
                                  "<span style='font-weight: 400;font-size:16px;margin-bottom:8px'>" +
                                  params.name +
                                  '</span>' +
                                  '<br/>扫码次数：' +
                                  params.value +
                                  '</div>'
                            : '';
                    }
                },
                visualMap: {
                    //视觉映射组件
                    show: false,
                    x: 'right',
                    y: 'bottom',
                    realtime: false, //拖拽时，是否实时更新

                    splitList: [
                        { start: 5000, end: 500000 },
                        { start: 4000, end: 5000 },
                        { start: 3000, end: 4000 },
                        { start: 2000, end: 3000 },
                        { start: 1000, end: 2000 },
                        { start: 0, end: 1000 }
                    ],
                    color: ['#B1E7F8', '#9feaa5', '#85daef', '#74e2ca', '#e6ac53', '#9fb5ea']
                },
                series: [
                    {
                        name: '扫码次数',
                        type: 'map',
                        mapType: 'china',
                        roam: true, //是否开启鼠标缩放和平移漫游
                        itemStyle: {
                            //地图区域的多边形 图形样式
                            normal: {
                                areaColor: '#B1E7F8',
                                borderColor: '#fff',
                                //是图形在默认状态下的样式
                                label: {
                                    show: false, //是否显示标签
                                    textStyle: {
                                        color: 'black'
                                    }
                                }
                            },
                            zoom: 1.4, //地图缩放比例,默认为1

                            emphasis: {
                                // areaColor: '#B1E7F8',
                                // areaColor: '#B1E7F8',
                                //是图形在高亮状态下的样式,比如在鼠标悬浮或者图例联动高亮时
                                label: { show: true }
                            }
                        },
                        left: '15%',
                        top: '10%', //组件距离容器的距离
                        data: this.arr,
                        nameMap: {
                            河北: '河北省',
                            山西: '山西省',
                            辽宁: '辽宁省',
                            吉林: '吉林省',
                            黑龙江: '黑龙江省',
                            江苏: '江苏省',
                            浙江: '浙江省',
                            安徽: '安徽省',
                            福建: '福建省',
                            江西: '江西省',
                            山东: '山东省',
                            河南: '河南省',
                            湖北: '湖北省',
                            湖南: '湖南省',
                            广东: '广东省',
                            海南: '海南省',
                            四川: '四川省',
                            贵州: '贵州省',
                            云南: '云南省',
                            陕西: '陕西省',
                            甘肃: '甘肃省',
                            青海: '青海省',
                            台湾: '台湾省',
                            内蒙古: '内蒙古自治区',
                            广西: '广西壮族自治区',
                            西藏: '西藏自治区',
                            宁夏: '宁夏回族自治区',
                            新疆: '新疆维吾尔自治区',
                            北京: '北京市',
                            天津: '天津市',
                            上海: '上海市',
                            重庆: '重庆市',
                            香港: '香港特别行政区',
                            澳门: '澳门特别行政区'
                        },
                        icon: 'circle', //  设置形状  类型包括 circle，rect ，roundRect，triangle，diamond，pin，arrow，none
                        itemWidth: 10, // 设置宽度
                        itemHeight: 10, // 设置高度
                        itemGap: 20 // 设置间距
                    }
                ]
            };
            // 使用刚指定的配置项和数据显示图表。
            myEcharts.setOption(option);
        },
        handleChange(e) {
            this.valuew = e;
            if (e[1]) {
                this.page.product_id = e[1];
            } else {
                this.page.product_id = '';
            }
            this.getDashboard();
        },
        // 微信授权code 
        // postWx_bind(){
        //     let that=this
        //     let obj={
        //         code:that.code
        //     }
        //     that.$get('/backapi/wx_bind', obj).then(function (res) {
               
        //     });
        // },
        // 产品列表
        getMessage() {
            let that = this;
            let obj = {
                page: 1,
                num: 1000
            };
            that.$get('/backapi/product', obj).then(function (res) {
                let arr = [
                    { value: 1, label: '地图展示-扫码分布' },
                    { value: 2, label: '地图展示-产品分布', children: [] }
                ];
                let product = [];
                if (res.count) {
                    res.data.map((item) => {
                        product.push({ value: item.id, label: item.product_name });
                    });
                    arr[1].children = product;
                    that.area = arr;
                }
            });
        },
        getDashboard() {
            let that = this;
            that.arr = [];
            that.area_scan_count = [];
            let obj = {
                start_time: that.page.start_time,
                end_time: that.page.end_time,
                product_id: that.page.product_id
            };
            that.$get('/backapi/dashboard', obj).then(function (res) {
                if (res.code == 200) {
                    if (res.data.area_info.length != 0) {
                        that.area_scan_count = res.data.area_info.sort((a, b) => {
                            return b.count - a.count;
                        });
                        let arr = [];
                        that.area_scan_count.map((item) => {
                            arr.push({ name: item.province_name, value: item.count });
                        });
                        that.arr = arr;
                    }
                    // console.log('res.data :>> ', res.data);
                    that.price = {
                        balance: res.data.balance,
                        sum_red_envelope_amount: res.data.sum_red_envelope_amount,
                        total_num: res.data.total_num
                    };
                    that.$nextTick(() => {
                        setTimeout(() => {
                            that.drawChina();
                        }, 1000);
                    });
                } else {
                    that.$message({
                        message: res.mag,
                        type: 'err'
                    });
                }
            });
        },
        // 点击省
        getShen(e) {
            this.row = JSON.parse(JSON.stringify(e));

            this.getProvince_dashboard();
        },
        // 获取日期
        getTime(e) {
            this.value = e;
            if (e) {
                this.page.start_time = this.$newDate(e[0]);
                this.page.end_time = this.$newDate(e[1]);
            } else {
                this.page.start_time = '';
                this.page.end_time = '';
            }
        },
        // 搜索
        getSearch() {
            let that = this;
            that.getDashboard();
        },
        //获取市排行
        getProvince_dashboard() {
            let that = this;
            let obj = {
                province_id: that.row.province_id,
                start_time: that.page.start_time,
                end_time: that.page.end_time,
                product_id: that.page.product_id
            };
            that.$get('/backapi/province_dashboard', obj).then(function (res) {
                if (res.code == 200) {
                    that.province_dashboard = res.data.sort((a, b) => {
                        return b.count - a.count;
                    });
                    that.resetDialogVisible = true;
                } else {
                    that.$message({
                        message: res.mag,
                        type: 'err'
                    });
                }
            });
        },
        // 支付信息
        getPayment() {
            let that = this;
            that.$get('/backapi/payment', {}).then(function (res) {
                if (res.code == 200) {
                    that.payDetail = res.data;
                    console.log(res);
                    that.backfillList0 = [
                        {
                            url: res.data.mch_cert,
                            name: res.data.mch_cert
                        }
                    ];
                    that.backfillList = [
                        {
                            url: res.data.mch_key,
                            name: res.data.mch_key
                        }
                    ];
                } else {
                    that.$message({
                        message: res.mag,
                        type: 'err'
                    });
                }
            });
        },
        getPay() {
            this.pay_DialogVisible = true;
            this.getPayment();
        },
        payDialogFalse() {
            this.pay_DialogVisible = false;
            this.payDetail = {};
            this.backfillList0 = [];
            this.backfillList = [];
            this.uploadData=new FormData()
        },
        handleRemove0() {
            this.payDetail.mch_cert = '';
            this.backfillList0 = [];
        },
        handleRemove() {
            this.payDetail.mch_key = '';
            this.backfillList = [];
        },
        handleExceed(files, fileList) {
            if (fileList.length >= 1) {
                this.$message({ message: '只能上传一个文件', type: 'error', duration: 1000 });
            }
        },
          change_mch_cert(e) {
            const file = e.raw
            this.uploadData.append('mch_cert',file);// 通过append向form对象添加数据,可以通过append继续添加数据
            this.$set(this.payDetail, 'mch_cert', file.name);
        },
         change_mch_key(e) {
            const file = e.raw
            this.uploadData.append('mch_key',file);// 通过append向form对象添加数据,可以通过append继续添加数据
            this.$set(this.payDetail, 'mch_key', file.name);
        },
        payDialogTrue1(data){
            let that = this;
            console.log(data);
            that.$put('/backapi/payment', data).then(function (res) {
                if (res.code == 200) {
                    // that.msg = '修改成功';
                    // that.notificationns = true;
                    // setTimeout(() => {
                    //     that.notificationns = false;
                    // }, 3000);
                    // that.payDialogFalse();
                } else {
                    // that.msg = res.msg;
                    // that.notificationns = true;
                    // setTimeout(() => {
                    //     that.notificationns = false;
                    // }, 3000);
                }
            });
        },
        payDialogTrue() { 
            let that = this;
            this.uploadData.append("sub_app_id", this.payDetail.app_id);
            this.uploadData.append("app_id", this.payDetail.app_id);
            this.uploadData.append("pid", this.payDetail.pid);
            this.uploadData.append("key", this.payDetail.key);
            this.uploadData.append("wechat_pay_serial_no", this.payDetail.wechat_pay_serial_no);
            this.uploadData.append("use_merchant_withdraw", this.payDetail.use_merchant_withdraw);
            this.uploadData.append("use_merchant_withdraw", this.payDetail.use_merchant_withdraw);
            // console.log( this.uploadData);
            // let obj = {
            //     app_id: that.payDetail.app_id, //微信公众号 app_id
            //     sub_app_id: that.payDetail.sub_app_id, //当前调起支付的小程序APPID
            //     pid: that.payDetail.pid, //商户号
            //     key: that.payDetail.key, //商户key
            //     wechat_pay_serial_no: that.payDetail.wechat_pay_serial_no, //商户证书序列号
            //     use_merchant_withdraw: that.payDetail.use_merchant_withdraw, //是否使用商户提现
            //     mch_key: that.formdata1 ? that.formdata1 : that.payDetail.mch_key, //私钥证书文件
            //     mch_cert: that.formdata ? that.formdata : that.payDetail.mch_cert //证书文件
            // };
            that.$put('/backapi/payment', this.uploadData).then(function (res) {
                if (res.code == 200) {
                    that.msg = '修改成功';
                    that.notificationns = true;
                    setTimeout(() => {
                        that.notificationns = false;
                    }, 3000);
                    that.payDialogFalse();
                } else {
                    that.msg = res.msg;
                    that.notificationns = true;
                    setTimeout(() => {
                        that.notificationns = false;
                    }, 3000);
                }
            });
        },
        // 添加金额
        getAdd() {
            this.add_balanceDialogVisible = true;
        },
        resetDialogTrue(formName) {
            let that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let obj = {
                        add_balance: Number(that.numberValidateForm.add_balance)
                    };
                    that.$post('/backapi/update_wallet', obj).then(function (res) {
                        that.msg = '添加成功';
                        that.notificationns = true;
                        setTimeout(() => {
                            that.notificationns = false;
                        }, 3000);
                        that.resetDialogFalse();
                        that.getDashboard();
                    });
                } else {
                    return false;
                }
            });
        },
        resetDialogFalse() {
            this.numberValidateForm.add_balance = '';
            this.add_balanceDialogVisible = false;
        }
    },
    mounted() {
        // 仪表盘
        let that = this;
        window.screenHeight = document.body.clientHeight;
        this.screenHeight = window.screenHeight;
        that.height = that.screenHeight - that.$refs.getheight.offsetHeight - that.$refs.getheight1.offsetHeight - 48 - 40 - 29;

        this.user_type = localStorage.getItem('user_type');
        if (localStorage.getItem('user_type') == 'user') {
        } else {
            if (that.chartShow1) {
                that.getDashboard();
            }
            window.onresize = function () {
                if (!that.timer) {
                    that.timer = true;
                    that.chartShow = false;
                    that.chartShow1 = false;
                    setTimeout(() => {
                        that.timer = false;
                        that.chartShow = true;
                        that.height = that.screenHeight - that.$refs.getheight.offsetHeight - that.$refs.getheight1.offsetHeight - 48 - 40 - 29;

                        that.getDashboard();
                    }, 500);
                }
            };
            that.getMessage();
            // that.postWx_bind()
        }
        if (localStorage.getItem('user_type') == 'super') {
            // that.getPayment();
        }
    },
    beforeDestroy() {
        window.onresize = null;
    }
};
</script>
<style lang="scss" scoped>
.flex_center {
    display: flex;
    align-items: center;
}
/deep/.flex_center .el-form-item {
    flex: 1;
    margin-right: 10px;
}
/deep/.el-upload--text {
    border: none;
    width: 188px;
    height: 39px;
}
/deep/.el-upload--text .input_button {
    width: 188px;
}
/deep/.u_pay .el-form-item__label {
    width: 100%;
    text-align: left;
}
/deep/.v_dol1 .el-input__inner {
    height: 48px;
    padding: 12px 16px;
    border: 1px solid #f2f4f8;
    filter: drop-shadow(0px 1px 1px #c1c7cd);
    border-radius: 8px;
    font-weight: 400;
    font-size: 16px;
    color: #697077;
}

.end {
    justify-content: space-between;
}
.ml20 {
    margin-left: 20px;
}
.v_buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 129px;
    height: 48px;
    background: #91d9f2;
    border: 2px solid #91d9f2;
    border-radius: 8px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.5px;
    color: #ffffff;
    margin-top: 24px;
    cursor: pointer;
}
/deep/.el-table th {
    background: rgba(177, 178, 180, 0.4) !important;
    z-index: 99;
    position: relative;
}
/deep/ .v_dol .el-dialog {
    padding: 24px;
    border: 1px solid #dde1e6;
    border-radius: 16px;
}

/deep/.v_dol .el-dialog .el-dialog__header {
    padding: 0;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/deep/.v_dol .el-dialog__headerbtn {
    position: relative;
    top: 0;
    right: 0;
}
/deep/.v_dol .el-dialog__close {
    font-size: 18px;
    color: #21272a;
}
/deep/.v_dol .el-dialog__title {
    color: #21272a;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
}
/deep/.v_dol .el-dialog__body {
    padding: 0;
}

.one {
    width: 16px;
    height: 16px;
    justify-content: center;
    background: #16307c;
    border-radius: 26px;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    letter-spacing: 0.005em;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 9px;
}
.two {
    background: rgba(22, 48, 124, 0.7) !important;
}
.thr {
    background: rgba(22, 48, 124, 0.4) !important;
}
.mr42 {
    margin-right: 42px;
}
.mb24 {
    margin-bottom: 24px;
}
.mr24 {
    margin-right: 24px;
}
.v_header {
    justify-content: space-between;
    margin-bottom: 24px;
}

/deep/.el-range__icon {
    color: #000;
}
/deep/ .el-range-separator {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.005em;
    color: #333333;
}
/deep/.el-range-input {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.005em;
    color: #333333;
    line-height: 0;
}
/deep/.el-input__inner {
    border-color: #16307c;
    // padding: 0 ;
    border: none;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.005em;
    color: #333333;
    line-height: 0;
}
/deep/.el-cascader .el-input .el-icon-arrow-down {
    color: #16307c;
    font-weight: 600;
    font-size: 20px;
}

.flex_down {
    display: flex;
    flex-direction: column;
    // width: 329px;
    flex: 1;
    padding: 20px 16px;
    // height: 104px;
    background: #ffffff;
    box-shadow: 1px 3px 8px rgba(22, 48, 124, 0.16);
    border-radius: 8px;

    .dollar {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        letter-spacing: 0.01em;
        color: #333333;
        line-height: 16px;
    }
    .balance {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
        letter-spacing: 0.01em;
        color: #333333;
        line-height: 32px;
    }
    .v_span {
        margin-bottom: 16px;
    }
}

.v_bottom {
    display: flex;
    justify-content: space-between;
}
.chartBox {
    width: 75%;
    height: 100%;
    background: #ffffff;
    box-shadow: 1px 3px 8px rgba(22, 48, 124, 0.16);
    border-radius: 8px;
    position: relative;
    margin-right: 24px;
}
#mapBox {
    position: absolute;
    width: 100%;
    height: 100%;
}

.flexdown {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background: #ffffff;
    box-shadow: 1px 3px 8px rgba(22, 48, 124, 0.16);
    border-radius: 8px;
    padding: 20px 16px;
    box-sizing: border-box;
}
.area_scan_count {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    cursor: pointer;
}
#mapChart {
    width: 100%;
    height: 100%;
}
</style>